<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    bottom
    color="white"
    :multi-line="true"
  >
    <div style="color: #366e1a; padding: 16px;">
      {{ $t('message.cookieBannerText1') }}
      <a href="/file/cookie_policy_tii.doc" target="_blank" style="color: #366e1a; text-decoration: underline;">
        {{ $t('message.cookieBannerLink') }}
      </a>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="#366e1a"
        text
        v-bind="attrs"
        @click="accept"
      >
        {{ $t('message.cookieBannerBtn') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      show: false
    }
  },
  mounted() {
    const accepted = localStorage.getItem('cookie_accepted')
    if (!accepted) {
      this.show = true
    }
  },
  methods: {
    accept() {
      this.show = false
      localStorage.setItem('cookie_accepted', 'true')
    }
  }
}
</script>

<style scoped>
</style>
